import { Grid, Typography } from "@mui/material"

import OneSelect2 from "../../../../../Components/OneSelect2/OneSelect2"

export const LabelSelect = ({ optionsSelect, name, labelWidth, inputWidth, componentXs, componentXl, componentHeight, labelText, inputValue, inputChange, typographySx, disabled = false }) => {
    return (
        <Grid xs={componentXs || true} xl={componentXl || true} sx={{ height: componentHeight, display: 'flex', flexDirection: 'row' }}>
            <div style={{ width: labelWidth }}>
                <Typography sx={typographySx}>
                    {labelText}
                </Typography>
            </div>
            <div style={{ width: inputWidth }}>
                <OneSelect2
                    name={name}
                    value={inputValue}
                    onChange={inputChange}
                    disabled={disabled}
                    options={optionsSelect}
                />
            </div>
        </Grid>
    )
}
